module.exports = __webpack_public_path__ + "static/media/no-credits.550d255b.png";